import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EmptyRepoQuoteTableComponent} from "../../quoteTable/empty-repo-quote-table/empty-repo-quote-table.component";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {GlobalLoaderService} from "../../../../services/global-loader.service";

@Component({
    selector: 'logzy-charge-details',
    templateUrl: './charge-details.component.html',
    styleUrls: ['./charge-details.component.scss','../../../dialog-box/dialog-box.scss']
})
export class ChargeDetailsComponent implements OnInit {

    chargesDataSource;
    displayedColumnsCharges: string[] = [];
    pageLength = 0;
    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    chargeData;
    set: boolean = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('title') title: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmptyRepoQuoteTableComponent>,
        private loaderService: GlobalLoaderService
    ) {
    }

    ngOnInit(): void {
        this.chargeData = this.data.chargeData;
        this.chargeData.requirement_charges.map((requirementCharge: any) => {
            requirementCharge.amount_per_unit = requirementCharge.quantity != 0 ? (Number(requirementCharge.total_amount) / Number(requirementCharge.quantity)).toFixed(2) : 0;
        })
        this.chargesDataSource = new MatTableDataSource(this.chargeData.requirement_charges);
        this.displayedColumnsCharges = ['charge_description', 'requirement', 'quantity', 'amount_per_unit', 'total_amount'];
    }

    cancelChargesDialog() {
        this.dialogRef.close();
    }

    onMouseMove(e: any) {
        this.dropped = true;
        if (e.clientX < (this.screenWidth / 2)) {//right shadow
            this.shadowX = 5;
        } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
            this.shadowX = -5;
        }
        if (e.clientY > (this.screenHeight / 2)) {//top shadow
            this.shadowY = -4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
            this.shadowY = 4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        }
    }
}
